module.exports = __webpack_public_path__ + "img/model_23_zh.720ffada.jpg";